module.exports = __webpack_public_path__ + "img/streak-flame.74c1ac1a.svg";